/* eslint-disable no-loop-func */
import React, { createContext, useContext } from 'react';
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import _ from 'lodash';

import { axios } from '../../../v5/utils/axios';
import { success, successAPI, errorAPI, getMaxPageSize, isNumeric, getCurrency, formatNumber } from '../../../v5/utils/utils';
import { AccountSettingType } from '../../../v5/utils/enums';
import { BillingTypes } from '../../../v5/pages/jobs/slice';


interface InitState {
  isLoading: boolean,

  accountBillingProfileId: number|null,
  invoiceTaxRate: number|null,
  purchaseTaxRate: number|null,

  isConnected: boolean,
  showSettings: boolean,
  defaultTaxRate: any,

  category: Array<any>,
}


function NewReducer() {
  const name = 'taxRateSlice';


  const initialState: InitState = {
    isLoading: false,

    accountBillingProfileId: null,
    invoiceTaxRate: null,
    purchaseTaxRate: null,
    
    isConnected: false,
    showSettings: false,
    defaultTaxRate: '',

    category: [],
  };


  const reducers = {
    setMainTaxRate: (state: InitState, action: PayloadAction<{ invoiceTaxRate: number|null, purchaseTaxRate: number|null }>) => {
      let invoiceTaxRate = (isNumeric(action.payload.invoiceTaxRate)) ? action.payload.invoiceTaxRate : null;
      let purchaseTaxRate = (isNumeric(action.payload.purchaseTaxRate)) ? action.payload.purchaseTaxRate : null;

      state.invoiceTaxRate = invoiceTaxRate;
      state.purchaseTaxRate = purchaseTaxRate;
    },
    setTaxRate: (state: InitState, action: PayloadAction<{ index: number|null, invoiceTaxRate: number|null, purchaseTaxRate: number|null }>) => {
      if(action.payload.index){
        let invoiceTaxRate = (isNumeric(action.payload.invoiceTaxRate)) ? action.payload.invoiceTaxRate : null;
        let purchaseTaxRate = (isNumeric(action.payload.purchaseTaxRate)) ? action.payload.purchaseTaxRate : null;

        let item: any = {
          index: action.payload.index,
          invoiceTaxRate: invoiceTaxRate,
          purchaseTaxRate: purchaseTaxRate,
        };
  
        let category = state.category;
        let index = category.findIndex((x) => x['index'] == action.payload.index);
        if (index === -1) {
          category.push(item);
        } else {
          category.splice(index, 1);
          category.push(item);
        }

        state.category = category;
      }
    },

    startReadDefaultProfile: (state: InitState) => {
      state.category = [];

      state.accountBillingProfileId = null;
      state.invoiceTaxRate = null;
      state.purchaseTaxRate = null;

      state.isConnected = false;
      state.showSettings = false;
      state.defaultTaxRate = '';
      
      state.isLoading = true;
    },
    finishReadDefaultProfile: (state: InitState, action: PayloadAction<{ data: any }>) => {
      let item = (action.payload && action.payload.data && action.payload.data.data && action.payload.data.data.length > 0) ? action.payload.data.data[0] : null;
      
      let accountBillingProfileId = (item && isNumeric(item.accountBillingProfileId)) ? item.accountBillingProfileId : null;
      let invoiceTaxRate = (item && isNumeric(item.invoiceTaxRate)) ? item.invoiceTaxRate : null;
      let purchaseTaxRate = (item && isNumeric(item.purchaseTaxRate)) ? item.purchaseTaxRate : null;
      
      let isConnectQuickbook = (item && (item.isConnectQuickbook === false || item.isConnectQuickbook === true)) ? item.isConnectQuickbook : false;
      let isConnectXero = (item && (item.isConnectXero === false || item.isConnectXero === true)) ? item.isConnectXero : false;
      let isConnected = (isConnectQuickbook || isConnectXero) ? true : false;

      state.accountBillingProfileId = accountBillingProfileId;
      state.invoiceTaxRate = invoiceTaxRate;
      state.purchaseTaxRate = purchaseTaxRate;

      state.isConnected = isConnected;
      state.showSettings = false;
      state.defaultTaxRate = '';

      state.isLoading = false;
    },
    
    startReadCustomerProfile: (state: InitState) => {
      state.category = [];

      state.accountBillingProfileId = null;
      state.invoiceTaxRate = null;
      state.purchaseTaxRate = null;
      
      state.isConnected = false;
      state.showSettings = false;
      state.defaultTaxRate = '';

      state.isLoading = true;
    },
    finishReadCustomerProfile: (state: InitState, action: PayloadAction<{ data: any }>) => {
      let item = (action.payload && action.payload.data && action.payload.data.billingProfile) ? action.payload.data.billingProfile : null;
      
      let accountBillingProfileId = (item && isNumeric(item.accountBillingProfileId)) ? item.accountBillingProfileId : null;
      let invoiceTaxRate = (item && isNumeric(item.invoiceTaxRate)) ? item.invoiceTaxRate : null;
      let purchaseTaxRate = (item && isNumeric(item.purchaseTaxRate)) ? item.purchaseTaxRate : null;
      
      let isConnectQuickbook = (item && (item.isConnectQuickbook === false || item.isConnectQuickbook === true)) ? item.isConnectQuickbook : false;
      let isConnectXero = (item && (item.isConnectXero === false || item.isConnectXero === true)) ? item.isConnectXero : false;
      let isConnected = (isConnectQuickbook || isConnectXero) ? true : false;

      state.accountBillingProfileId = accountBillingProfileId;
      state.invoiceTaxRate = invoiceTaxRate;
      state.purchaseTaxRate = purchaseTaxRate;

      state.isConnected = isConnected;
      state.showSettings = false;
      state.defaultTaxRate = '';

      state.isLoading = false;
    },

    startReadDefaultTaxRate: (state: InitState) => {
      state.showSettings = false;
      state.isLoading = true;
    },
    finishReadDefaultTaxRate: (state: InitState, action: PayloadAction<{ data: any }>) => {
      let item = (action.payload && action.payload.data && action.payload.data.value) ? action.payload.data.value : '';
      
      state.defaultTaxRate = item;
      state.showSettings = (!state.isConnected && item != '') ? true : false;
      state.isLoading = false;
    },

    startSaveDefaultTaxRate: (state: InitState) => {
      state.isLoading = true;
    },
    finishSaveDefaultTaxRate: (state: InitState, action: PayloadAction<{ data: any }>) => {
      state.isLoading = false;
    },
    
    setShowSettings: (state: InitState, action: PayloadAction<boolean>) => {
      state.showSettings = action.payload;
    },
    setDefaultTaxRate: (state: InitState, action: PayloadAction<any>) => {
      state.defaultTaxRate = action.payload;
    },
  };


  const func = {
    getTax: (isTaxInclusive: boolean, price: number, percent: number|null) => {
      let tax: number = 0;

      if(isTaxInclusive === true){
        if(percent != null && isNumeric(percent)){
          try {
            tax = (100 / (percent + 100)) * price
          } catch (e) {
            tax = price;
          }
        } else {
          tax = price;
        }
      } else {
        tax = price;
      }

      return tax;
    },
    getWithoutTax: (isTaxInclusive: boolean, price: number, percent: number|null) => {
      let plusTax = func.getTax(isTaxInclusive, price, percent);
      return getCurrency() + formatNumber(plusTax) + ' without tax';
    },
    getWithoutTaxRate: (isTaxInclusive: boolean, price: number) => {
      return getCurrency() + formatNumber(price) + ' without tax';
    },
    getTaxPercentage: (billingType: number|null, invoiceTaxRate: number|null, purchaseTaxRate: number|null, taxRate: { isConnected: boolean, defaultTaxRate: any }): number|null => {
      let isConnected = (taxRate && (taxRate.isConnected == false || taxRate.isConnected == true)) ? taxRate.isConnected : false;
      let defaultTaxRate = (taxRate && taxRate.defaultTaxRate && taxRate.defaultTaxRate != '') ? parseFloat(taxRate.defaultTaxRate) : null;

      return isConnected ? (billingType === BillingTypes.Purchase) ? purchaseTaxRate : invoiceTaxRate : defaultTaxRate;
    },
    getTaxRate: (isTaxInclusive: boolean, item: any|null, taxRate: { invoiceTaxRate: number|null, purchaseTaxRate: number|null, category: Array<any>, isConnected: boolean, defaultTaxRate: any }) => {
      let invoiceTaxRate = (taxRate && isNumeric(taxRate.invoiceTaxRate)) ? taxRate.invoiceTaxRate : null;
      let purchaseTaxRate = (taxRate && isNumeric(taxRate.purchaseTaxRate)) ? taxRate.purchaseTaxRate : null;

      let chargeCategoryId = (item && item.chargeCategoryId) ? item.chargeCategoryId : null;
      if(chargeCategoryId && taxRate.category && taxRate.category.length > 0){
        let catItems = taxRate.category.filter((x: any) => x.index == chargeCategoryId);
        if(catItems && catItems.length > 0){
          let invoiceTaxRateC = (catItems && catItems[0] && isNumeric(catItems[0].invoiceTaxRate)) ? catItems[0].invoiceTaxRate : null;
          let purchaseTaxRatec = (catItems && catItems[0] && isNumeric(catItems[0].purchaseTaxRate)) ? catItems[0].purchaseTaxRate : null;

          invoiceTaxRate = invoiceTaxRateC;
          purchaseTaxRate = purchaseTaxRatec;
        }
      }

      let billingType = (item) ? item.billingType : null;
      let price = (item) ? item.price : null;

      let getTaxPercentage: number|null = func.getTaxPercentage(billingType, invoiceTaxRate, purchaseTaxRate, taxRate);
      return func.getWithoutTax(isTaxInclusive, price, getTaxPercentage);
    },
    getTaxRateColumn: (isTaxInclusive: any, price: any, priceTaxRate: any) => {
      return <>
        <div>{getCurrency() + formatNumber(price)}</div>
        {(isTaxInclusive && isNumeric(price)) && <i className={'fw-light text-muted fs-7'}>{func.getWithoutTaxRate(isTaxInclusive, priceTaxRate)}</i>}
      </>
    },
    getTaxRateField: (item: any|null, iTaxRate: number|null, pTaxRate: number|null, taxRate: any) => {
      if(item){
        let invoiceTaxRate = (item && item.chargeCategory && item.chargeCategory.invoiceTaxRate) ? item.chargeCategory.invoiceTaxRate : iTaxRate;
        let purchaseTaxRate = (item && item.chargeCategory && item.chargeCategory.purchaseTaxRate) ? item.chargeCategory.purchaseTaxRate : pTaxRate;

        return <>
          <div>{getCurrency() + formatNumber(item.price)}</div>
          {(item.isTaxInclusive && isNumeric(item.price)) && <i className={'fw-light text-muted fs-7'}>{func.getWithoutTax(item.isTaxInclusive, item.price, func.getTaxPercentage(item.billingType, invoiceTaxRate, purchaseTaxRate, taxRate))}</i>}
        </>
      }
    },
  }


  const apis = {
    getDefaultProfileApi: (callback: (state: boolean, data: any) => void) => async (dispatch: any) => {
      dispatch(actions.startReadDefaultProfile());

      let params = {
        isActive: true,
        isDefault: true,
      };

      await axios.get('AccountBillingProfile', { params: params }).then((result: any) => {
        let data = result.data;
        
        successAPI(data);

        callback(true, data);
        dispatch(actions.finishReadDefaultProfile({ data: data }));
      }).catch((error: any) => {
        errorAPI(error);
        
        callback(false, null);
        dispatch(actions.finishReadDefaultProfile({ data: null }));
      });
    },

    getCustomerProfileApi: (customerId: number|null, callback: (state: boolean, data: any) => void) => async (dispatch: any) => {
      dispatch(actions.startReadCustomerProfile());

      if(customerId){
        await axios.get('customer/' + customerId).then((result: any) => {
            let data = result.data;
            
            successAPI(data);

            callback(true, data);
            dispatch(actions.finishReadCustomerProfile({ data: data }));
        }).catch((error: any) => {
            errorAPI(error);
            
            callback(false, null);
            dispatch(actions.finishReadCustomerProfile({ data: null }));
        });
      } else {
        dispatch(actions.finishReadCustomerProfile({ data: null }));
      }
    },

    getDefaultTaxRateApi: (callback: (state: boolean, data: any) => void) => async (dispatch: any) => {
      dispatch(actions.startReadDefaultTaxRate());

      await axios.get('AccountSetting/type/' + AccountSettingType.DefaultTaxRate).then((result: any) => {
        let data = result.data;
        
        successAPI(data);

        callback(true, data);
        dispatch(actions.finishReadDefaultTaxRate({ data: data }));
      }).catch((error: any) => {
        errorAPI(error);
        
        callback(false, null);
        dispatch(actions.finishReadDefaultTaxRate({ data: null }));
      });
    },

    callSaveDefaultTaxRateApi: (params: any, callback: (state: boolean, data: any) => void) => async (dispatch: any) => {
      dispatch(actions.startSaveDefaultTaxRate());

      await axios.put('AccountSetting', params).then((result: any) => {
          let data = result.data;
          
          // successAPI(data);
          success('Updated successfully', 'Tax rate is updated.');

          callback(true, data);
          dispatch(actions.finishSaveDefaultTaxRate({ data: data }));
      }).catch((error: any) => {
          errorAPI(error);
          
          callback(false, null);
          dispatch(actions.finishSaveDefaultTaxRate({ data: null }));
      });
    },
  };


  const { reducer, actions } = createSlice({
    name,
    initialState,
    reducers,
  });


  return {
    reducer,
    ...actions,
    ...apis,
    ...func,
  };
}


export default NewReducer();